.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 11, 11, 0.8);
}

.modal {
  position: relative;
  width: 580px;
  max-width: calc(100vw - 50px);
  max-height: calc(100vh - 50px);
  overflow: auto;
  padding: 30px;
  background: white;
  font-size: 16px;
  cursor: default;
  line-height: 1.4;
}

.x {
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  padding: 20px;
  opacity: 1;
  font-size: 44px;
  line-height: 0.5;
  border: none;
  background: none;
  user-select: none;
  cursor: pointer;
}
